import React, { Component } from "react";
import { Button } from "reactstrap";
import { Container, Row, Col } from "reactstrap";

import { Link } from "react-router-dom";
import CourseCards from './CourseCards';
import Academy from './../../CompaniesPage/AcademyComponent/academyComponent';

import "./style.css";

class Courses extends Component {
  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col sm={{ size: 12 }}>
              <h1 className="all-headers text-center mt-0 mb-3 fc-line">Our Opportunity Creating Courses</h1>
              {/* <hr className="heading-underline mb-5" /> */}
            </Col>
          </Row>
        </Container>

        <CourseCards
          title1={'Software Engineering'}
          text1={'Become a successful Engineer with this world-class full-time immersive course. '}
          cta={"Learn More"}
         
          title2={'Data Science & Analytics'}
          text2={'Harness the transformative power of data and analytics through this full-time immersive course.'}

          title3={'Digital Marketing'}
          text3={'Dive into the modern world of digital marketing and media with this full-time immersive course.'}

          title4={'Experience Design'}
          text4={'Experience a paradigm shift towards design thinking through this full-time immersive course.'}
        />

        <Container>
          <Row>
            <Col>
              <h3 className="path-title text-center">We have programs that fit your schedule.</h3>
            </Col>
          </Row>
        </Container>
        <div className='d-flex justify-content-center'>
          <Link to="/browse" className='d-inline-block'>
            <Button className="courses-button">Browse All Our Courses</Button>{" "}
          </Link>
        </div>

        <Academy heading={"Company Sponsored Courses"}  />
      </div>
    );
  }
}

export default Courses;
